import { useEffect, useState } from 'react';

export type UseRerenderOnIntervalArgs = {
    isDisabled?: boolean;
    interval?: number;
};

export const useRerenderOnInterval = ({ isDisabled, interval }: UseRerenderOnIntervalArgs) => {
    const [, setCount] = useState(0);

    useEffect(() => {
        if (isDisabled) return;

        const intervalTimer = setInterval(() => {
            setCount((_) => _ + 1);
        }, interval || 100);
        return () => clearInterval(intervalTimer);
    }, [interval, isDisabled]);
};
